import { render, staticRenderFns } from "./communicationDashboardPush.vue?vue&type=template&id=36cef14c&scoped=true"
import script from "./communicationDashboardPush.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cef14c",
  null
  
)

export default component.exports